// services/kontoVop.js — протоколите за ВОП (чл. 117) → файл за „Импорт на
// записвания" в Конто 6 (ПРОМТ-18). Чисти функции, без db — по модела на
// services/zaplati.js.
//
// Източникът на истината за формата е Konto6_VOP_Protokoli_Import.md: TXT с
// ФИКСИРАНА ширина на 22 колони, Windows-1251, CRLF (и след последния ред),
// ред 1 имената на колоните, ред 2 ширините, после по ДВА реда на протокол —
// Дт 4531 и Кт 4532 с еднакъв ITEM. Партидата (ACC_LOT) е кодовете на
// аналитичните нива, всеки допълнен до 20 знака: [вид сделка][контрагент][№ на
// фактурата на доставчика].
//
// Контрагентът (ниво 2) е по два начина — т. 3.2 от спецификацията:
//  А) Булстат: Конто го търси в номенклатурата и ако го няма, създава нов от
//     колоните PARTNER_*. Това е подразбирането — нищо не трябва да се
//     настройва предварително.
//  Б) Код: кодовете на доставчика в ном. 80 (доставчик) и 85 (клиент) се
//     пишат направо, PARTNER_* остават празни. Без риск от нов контрагент —
//     затова, щом за доставчика има записани кодове, те се ползват.

const { round2 } = require('./totals');
const { encodeWin1251 } = require('./zaplati');

// Колоните и ширините им — в този ред, нищо не се мести (т. 2.1). Ширина,
// по-малка от името на колоната, слива заглавията и Конто не ги разпознава.
const COLUMNS = [
  ['DOC_NO', 20], ['DOC_VALEUR', 11], ['FOLDER', 10], ['DOC_TYPE', 10], ['DOC_DATE', 10],
  ['ITEM', 10], ['CC_DATE', 10], ['CODE_OP', 10], ['VALUE', 20], ['ACC_NO', 10],
  ['ACC_LOT', 400], ['QTY', 20], ['PRICE', 20], ['CURRVALUE', 20], ['EXCHANGE_RATE', 20],
  ['NET_VALUE', 20], ['VAT_VALUE', 20], ['TEXT', 60], ['PARTNER_ID', 15], ['PARTNER_VAT_ID', 15],
  ['PARTNER_NAME', 64], ['PARTNER_ADDRESS', 64],
];
const LOT_WIDTH = 20;      // всеки аналитичен код в партидата (т. 3)
const CRLF = '\r\n';

// Настройките по фирма, когато не е записано нищо — стойностите на ТЕЛ ДЕМ от
// спецификацията. Всяка фирма може да ги смени от екрана на протоколите.
const DEFAULTS = {
  folder: '1',          // папка в Конто
  doc_type: '979',      // „Протокол или друг документ"
  acc_dt: '4531',       // начислен ДДС за покупките
  acc_kt: '4532',       // начислен ДДС за продажбите
  deal_dt: '04',        // вид сделка покупки (ном. 51) на реда 4531
  deal_kt: '03',        // вид сделка продажби (ном. 510) на реда 4532
  text: '',             // обяснителен текст; празно = предметът на доставката
  valeur: 'eom',        // 'eom' = последният ден на месеца; 'doc' = датата на протокола
};

function isEmpty(v) { return v === undefined || v === null || String(v).trim() === ''; }

// Ефективните кодове: подразбиранията, презаписани от непразните на фирмата.
function codesOf(settings) {
  const over = (settings && settings.codes && typeof settings.codes === 'object') ? settings.codes : {};
  const out = Object.assign({}, DEFAULTS);
  for (const k of Object.keys(DEFAULTS)) if (!isEmpty(over[k])) out[k] = String(over[k]).trim();
  return out;
}

// Ключът на доставчика в настройките: ДДС номерът без интервали, с главни
// букви; без ДДС номер — името. Така „IE9692928F" и „ie 9692928f" са едно.
function supplierKey(p) {
  const vat = String((p && p.supplier_vat) || '').replace(/\s+/g, '').toUpperCase();
  if (vat) return vat;
  return String((p && p.supplier_name) || '').trim().toUpperCase().replace(/\s+/g, ' ');
}

// ---- Форматиране на стойностите ----------------------------------------------

// ISO (гггг-мм-дд) → дд-ММ-гггг (т. 2). Невалидна дата → празно.
function dmy(iso) {
  const s = String(iso || '').slice(0, 10);
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s);
  return m ? m[3] + '-' + m[2] + '-' + m[1] : '';
}
// Последният ден от месеца на ISO дата, като ISO.
function eomIso(iso) {
  const s = String(iso || '').slice(0, 10);
  const m = /^(\d{4})-(\d{2})/.exec(s);
  if (!m) return '';
  const last = new Date(Date.UTC(+m[1], +m[2], 0)).getUTCDate();
  return m[1] + '-' + m[2] + '-' + String(last).padStart(2, '0');
}
function fmt2(n) { return round2(n).toFixed(2); }

// Номерът на протокола: 10 цифри с водещи нули (т. 2.1). Номер с представка
// или букви остава както е — водещите нули не се губят, защото е низ.
function docNo(number) {
  const s = String(number || '').trim();
  return /^\d{1,10}$/.test(s) ? s.padStart(10, '0') : s;
}

// Знак извън Windows-1251 (ü, ß, ё…) би спрял целия файл. Имената на
// чуждестранните доставчици често имат такива — сваляме диакритиките
// (Müller → Muller), а каквото остане неизразимо, става „?". Кирилицата и
// ASCII минават непипнати.
function cp1251Safe(s) {
  s = String(s || '');
  let out = '';
  for (const ch of s) {
    try { encodeWin1251(ch); out += ch; continue; } catch (e) { /* пада долу */ }
    const plain = ch.normalize('NFD').replace(/[̀-ͯ]/g, '');
    let ok = '';
    try { encodeWin1251(plain); ok = plain; } catch (e2) { ok = '?'; }
    out += ok || '?';
  }
  return out;
}

// Стойност в колона: вляво, допълнена с интервали до ширината; по-дълга се
// реже (т. 2). Дължината се мери в ЗНАЦИ, а всеки знак в cp1251 е един байт —
// значи и в байтове редът е точно 859.
function cell(v, width) {
  const s = cp1251Safe(v).replace(/[\r\n\t]/g, ' ');
  return s.length >= width ? s.slice(0, width) : s + ' '.repeat(width - s.length);
}

// Партидата: кодовете на нивата, всеки до 20 знака, целият низ до 400.
function lot(levels) {
  return levels.map((v) => cell(v, LOT_WIDTH)).join('');
}

// ---- Построяването -----------------------------------------------------------

// Текстът на статията: настройката на фирмата, иначе предметът на доставката
// (първият ред), иначе „ВОП".
function textOf(codes, p) {
  if (!isEmpty(codes.text)) return codes.text;
  const d = String((p && p.description) || '').split(/\r?\n/)[0].trim();
  return d || 'ВОП';
}

// protocols: протоколите за файла (вече подбрани — кои, решава route-ът);
// settings: { codes, suppliers } на фирмата; todayIso: датата на файла
// (CC_DATE). Връща { rows, items, stops, warnings, skipped }:
//  rows     — редовете на файла като масиви от 22 стойности (без заглавията);
//  items    — по един на протокол, за прегледа на екрана;
//  stops    — грешки, при които файл НЕ се прави (Конто би го отказал или би
//             осчетоводил грешно);
//  warnings — за проверка, файлът излиза;
//  skipped  — протоколи, които не влизат (напр. с ДДС 0), с причина.
function buildRows(protocols, settings, todayIso) {
  const codes = codesOf(settings);
  const suppliers = (settings && settings.suppliers && typeof settings.suppliers === 'object') ? settings.suppliers : {};
  const rows = [], items = [], stops = [], warnings = [], skipped = [];
  // Доставчиците без кодове — предупреждение ПО ВЕДНЪЖ на доставчик (т. 3ж).
  const noCodes = new Set();
  const ccDate = dmy(todayIso);
  let item = 0;

  for (const p of (Array.isArray(protocols) ? protocols : [])) {
    const no = docNo(p.number);
    const label = 'Протокол № ' + (p.number || '?');
    const vat = round2(p.vat_amount);
    const base = round2(p.tax_base);
    if (!vat) { skipped.push({ id: p.id, number: p.number, reason: 'ДДС 0.00 — няма какво да се начисли по ' + codes.acc_dt + '/' + codes.acc_kt + '.' }); continue; }
    if (p.currency && p.currency !== 'EUR') { stops.push(label + ' е във валута ' + p.currency + ' — файлът е само за протоколи в евро.'); continue; }
    if (!dmy(p.protocol_date)) { stops.push(label + ' е без валидна дата.'); continue; }
    if (!p.supplier_name) { stops.push(label + ' е без доставчик.'); continue; }

    // Ниво 3: № на фактурата на доставчика. Без него — номерът на протокола,
    // с предупреждение: партидата трябва да е пълна, иначе Конто отказва реда.
    let invNo = String(p.supplier_invoice_number || '').trim();
    if (!invNo) { invNo = no; warnings.push(label + ': няма № на фактурата на доставчика — в партидата влиза номерът на протокола.'); }
    if (invNo.length > LOT_WIDTH) { warnings.push(label + ': № на фактурата „' + invNo + '" е над ' + LOT_WIDTH + ' знака и се реже.'); }

    // Ниво 2: по код (вариант Б) или по Булстат (вариант А).
    const sup = suppliers[supplierKey(p)] || {};
    const sc = String(sup.supplier_code || '').trim(), cc = String(sup.customer_code || '').trim();
    let dtPartner, ktPartner, partner;
    if (sc && cc) {
      dtPartner = sc; ktPartner = cc;
      partner = { id: '', vat: '', name: '', address: '', mode: 'code' };
    } else if (sc || cc) {
      stops.push(label + ': за доставчика „' + p.supplier_name + '" е записан само единият код за Конто (доставчик „' + sc + '", клиент „' + cc + '"). Попълнете и двата или изтрийте и двата.');
      continue;
    } else {
      const vatNo = String(p.supplier_vat || '').replace(/\s+/g, '').toUpperCase();
      const pid = String(sup.partner_id || '').trim() || vatNo;
      if (!pid) { stops.push(label + ': доставчикът „' + p.supplier_name + '" е без ДДС номер и без идентификатор в настройките — Конто няма по какво да го намери.'); continue; }
      if (pid.length > 13) warnings.push(label + ': идентификаторът „' + pid + '" е над 13 знака (границата на Конто).');
      // Промени 16.10, т. 3ж: Конто, като не намери доставчика по Булстат,
      // създава нов контрагент — с код, по-дълъг от тези на фирмата, и
      // програмата се обърква. Файлът излиза, но човекът трябва да знае.
      const nk = supplierKey(p);
      if (!noCodes.has(nk)) {
        noCodes.add(nk);
        warnings.push('Доставчикът „' + p.supplier_name + '" е без кодове за Конто — Конто ще го търси по „' + pid + '" и ако не го намери, ще създаде нов контрагент с код, по-дълъг от вашите. За да не става — запишете кодовете му (доставчик и клиент) в „Действия → Настройки за Конто…".');
      }
      dtPartner = pid; ktPartner = pid;
      partner = { id: pid, vat: vatNo, name: p.supplier_name || '', address: p.supplier_country || '', mode: 'bulstat' };
    }

    const valeurIso = codes.valeur === 'doc' ? String(p.protocol_date).slice(0, 10) : eomIso(p.protocol_date);
    const text = textOf(codes, p);
    item++;
    const common = {
      DOC_NO: no, DOC_VALEUR: dmy(valeurIso), FOLDER: codes.folder, DOC_TYPE: codes.doc_type, DOC_DATE: dmy(p.protocol_date),
      ITEM: String(item), CC_DATE: ccDate, VALUE: fmt2(vat), QTY: '0.000', PRICE: '0.000', CURRVALUE: '0.000',
      EXCHANGE_RATE: '0.0000000', NET_VALUE: fmt2(base), VAT_VALUE: '0', TEXT: text,
      PARTNER_ID: partner.id, PARTNER_VAT_ID: partner.vat, PARTNER_NAME: partner.name, PARTNER_ADDRESS: partner.address,
    };
    const dt = Object.assign({}, common, { CODE_OP: '3', ACC_NO: codes.acc_dt, ACC_LOT: lot([codes.deal_dt, dtPartner, invNo]) });
    const kt = Object.assign({}, common, { CODE_OP: '4', ACC_NO: codes.acc_kt, ACC_LOT: lot([codes.deal_kt, ktPartner, invNo]) });
    rows.push(COLUMNS.map(([c]) => dt[c]), COLUMNS.map(([c]) => kt[c]));
    items.push({
      id: p.id, number: p.number, doc_no: no, protocol_date: p.protocol_date, valeur: valeurIso,
      supplier_name: p.supplier_name, supplier_vat: p.supplier_vat, invoice_no: invNo,
      tax_base: base, vat_amount: vat, text,
      dt: codes.acc_dt + ' [' + codes.deal_dt + '][' + dtPartner + '][' + invNo + ']',
      kt: codes.acc_kt + ' [' + codes.deal_kt + '][' + ktPartner + '][' + invNo + ']',
      partner_mode: partner.mode,
    });
  }
  return { rows, items, stops, warnings, skipped, codes };
}

// Заглавните два реда + данните → текстът на файла (преди кодирането).
// columns (по избор, ПРОМТ-31): 22-те плюс допълнителни колони САМО за този
// файл — L_<ном.>_NAME, от които Конто взима името на нов елемент на
// номенклатура (ОТГОВОР-ПРОМТ-30, т. 5.1: допълнителна колона е разрешена,
// ако я има в заглавието и в реда с ширините). ВОП-ът и продажбите не ги
// подават — техният файл е непроменен.
function renderTxt(rows, columns) {
  const cols = Array.isArray(columns) && columns.length ? columns : COLUMNS;
  const head = cols.map(([c, w]) => cell(c, w)).join('');
  const widths = cols.map(([, w]) => cell(String(w), w)).join('');
  const lines = [head, widths].concat((rows || []).map((r) => cols.map(([, w], i) => cell(r[i] == null ? '' : r[i], w)).join('')));
  return lines.join(CRLF) + CRLF;
}

// HRONOLOGYддММггггччммсс.TXT от дата (локално софийско време).
function makeFilename(d) {
  const p = (n) => String(n).padStart(2, '0');
  return 'HRONOLOGY' + p(d.getDate()) + p(d.getMonth() + 1) + d.getFullYear() + p(d.getHours()) + p(d.getMinutes()) + p(d.getSeconds()) + '.TXT';
}

// Днес в София като обект Date с локалните полета (за името на файла) и ISO.
function nowSofia() {
  const d = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Sofia' }));
  const iso = d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
  return { date: d, iso };
}

module.exports = { COLUMNS, DEFAULTS, codesOf, supplierKey, buildRows, renderTxt, makeFilename, nowSofia, docNo, dmy, eomIso, cp1251Safe, encodeWin1251, lot, cell };
